import { Bell } from 'lucide-react';
import { SelectableCard } from './SelectableCard';
import { Section } from '@vnetwork/ui/layout';
import { Card, Checkbox } from '@vnetwork/ui/primitives';
import { EmptyState } from '@vnetwork/ui/data';
import type { NotificationsCallback } from '@/api/media/vod-notifications-types';
import type { JobFormData } from './use-job-create-form';
import styles from './JobCreateNotificationSection.module.css';
import tileStyles from './SelectableTile.module.css';

interface Props {
  form: JobFormData;
  notifications: NotificationsCallback[];
  updateNotification: (value?: number) => void;
}

export function JobCreateNotificationSection({ form, notifications, updateNotification }: Props) {
  return (
    <Section title="Notification" style={{ marginBottom: 0 }}>
      <Card flat className={styles.cardInner}>
        <p className={styles.description}>
          Select a notification callback URL to be called when this job completes.
        </p>

        {notifications.length === 0 ? (
          <EmptyState
            icon={<Bell size={20} />}
            title="No callbacks configured"
            description="Add notification callbacks under the Notifications section first."
            size="sm"
          />
        ) : (
          <div className={styles.list}>
            {notifications.map((n) => {
              const selected = form.callback_id === n.id;
              return (
                <SelectableCard
                  key={n.id}
                  selected={selected}
                  className={`${tileStyles.tile} ${styles.item} ${selected ? tileStyles.tileActive : ''}`}
                  onSelect={() => updateNotification(selected ? undefined : n.id)}
                >
                  <Checkbox
                    checked={selected}
                    onCheckedChange={() => updateNotification(selected ? undefined : n.id)}
                    aria-hidden
                    tabIndex={-1}
                    style={{ pointerEvents: 'none', flexShrink: 0 }}
                  />
                  <div className={styles.itemBody}>
                    <p className={styles.itemName}>{n.name}</p>
                    <p className={styles.itemUrl}>{n.url}</p>
                  </div>
                </SelectableCard>
              );
            })}
          </div>
        )}
      </Card>
    </Section>
  );
}
